import React from 'react';
import { PageLayoutProps } from './interface';
import { Heading, Label, VStack } from '@medely/ui-kit';
import { usePageTitle } from './TitleProvider';

export const PageLayout = ({ title, subtitle, children }: PageLayoutProps) => {
  usePageTitle(title);
  return (
    <>
      <VStack pt={4} px={2}>
        <Heading size="m">{title}</Heading>
        {subtitle && <Label size="m">{subtitle}</Label>}
      </VStack>
      {children}
    </>
  );
};
